import { Component, Input, OnInit } from '@angular/core';
import { EventManager } from '@angular/platform-browser';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-xtheme',
  templateUrl: './xtheme.component.html',
  styleUrls: ['./xtheme.component.styl']
})
export class XthemeComponent implements OnInit {
  deviceMode: any = null;
  @Input() theme = '';

  constructor(
    private eventManager: EventManager,
    private utils: UtilsService
  ) { }

  ngOnInit() {
    this.checkDevice();
    this.eventManager.addGlobalEventListener('window', 'orientationchange', (ev: any) => {
      this.checkDevice();
    });
    this.eventManager.addGlobalEventListener('window', 'resize', (ev: any) => {
      this.checkDevice();
    });
  }

  checkDevice() {
    // 1. 优先检查 URL 参数 (?device=pc 或 ?device=mobile)
    const params = new URLSearchParams(window.location.search);
    const forceDevice = params.get('device');

    if (forceDevice === 'pc') {
      this.deviceMode = 90;
      return;
    } else if (forceDevice === 'mobile') {
      this.deviceMode = 0;
      return;
    }

    // 2. 检查屏幕宽度 (如果宽度 > 768，通常视为 PC 布局)
    const isWideScreen = window.innerWidth > 768;

    if (isWideScreen) {
      this.deviceMode = 90; // 强制 PC 模式
    } else {
      // 3. 回退到原始的 orientation 判断
      // 在 PC 浏览器中 window.orientation 可能是 undefined，这里做一个兼容处理
      if (window.orientation !== undefined) {
        this.deviceMode = window.orientation;
      } else {
        // 如果是智能设备且高度大于宽度，视为竖屏移动端
        if (this.utils.isSmartDevice() && window.innerHeight > window.innerWidth) {
          this.deviceMode = 0;
        } else {
          this.deviceMode = 90;
        }
      }
    }
  }

}
